import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useUser } from '../context/UserContext';
import { HOME_PATH, UPLOAD_INE_PATH, WELCOME_PATH } from './routePaths';

/**
 * Same guards as PrivateRoute (authenticated + INE uploaded), plus admin-only.
 * Nest under PrivateRoute in App, or use standalone — both patterns work.
 * Non-admins are sent to the main app home.
 */
function AdminRoute(): React.ReactElement {
  const { isAuthenticated, isInitialized, user } = useUser();
  const location = useLocation();
  const isOnUploadIne = location.pathname === UPLOAD_INE_PATH;

  if (!isInitialized) {
    return <CircularProgress />;
  }

  if (!isAuthenticated) {
    return <Navigate to={WELCOME_PATH} replace />;
  }

  if (user && user.ineUploaded !== true && !isOnUploadIne) {
    return <Navigate to={UPLOAD_INE_PATH} replace />;
  }

  if (!user?.isAdmin) {
    return <Navigate to={HOME_PATH} replace />;
  }

  return <Outlet />;
}

export default AdminRoute;
